/* @flow*/
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import withContext from 'recompose/withContext';
import T from 'prop-types';

const Component: any = withContext({ muiTheme: T.object }, () => ({
  muiTheme: getMuiTheme(),
}))(({ children }) => children);

export default Component;
